<template>
  <v-app id="inspire" class="fontLao">
    <div>
      <v-toolbar flat color="white">
        <v-toolbar-title class="fontLao">ອັດຕາແລກປ່ຽນ</v-toolbar-title>
        <v-divider
          class="mx-2"
          inset
          vertical
        ></v-divider>
        
        <v-spacer></v-spacer>
               <v-text-field
          v-model="search"
          append-icon="search"
          label="ຊອກຫາ"
          single-line
          hide-details
          
        ></v-text-field>
  <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="500px">
          <v-btn slot="activator" color="primary" dark class="mb-2 fontLao">ເພີ່ມ</v-btn>
          <v-card>
            <v-card-title>
              <span class="headline fontLao">{{ formTitle }}</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6 md6>
                      
                    <v-text-field class="fontLao" v-model="editedItem.lak" type="number" label="ກີບ(LAK)"></v-text-field>
                    <v-text-field class="fontLao" v-model="editedItem.usd" type="number" label="ໂດລາ(USD)"></v-text-field>
                    
                  </v-flex>
            
                </v-layout>
              </v-container>
            </v-card-text>
  
            <v-card-actions>
              <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="close" class="fontLao">ຍົກເລີກ</v-btn>
                <v-btn color="blue darken-1" flat @click.native="save" class="fontLao">ບັນທືກ</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

    

      </v-toolbar>

      <v-data-table
        :headers="headers"
        :items="mydata"
        :search="search"
        :rows-per-page-items=[10,20,50,100,500]
        v-bind:pagination.sync="pagination"
        class="elevation-1">
        <template slot="items" slot-scope="props">
          <td>{{ props.item.time }}</td>
       
          <td class="text-xs-center">{{ props.item.lak }}</td>
          <td class="text-xs-center">{{ props.item.usd }}</td>
          <td class="text-xs-center px-0">
            <v-icon
              small
              class="mr-2"
              @click="editItem(props.item)"
            >
              edit
            </v-icon>
            <v-icon
              small
              @click="deleteItem(props.item)"
            >
              delete
            </v-icon>
          </td>
        </template>
        <template slot="no-data">
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
      </v-data-table>
    </div>
  </v-app>
</template>
<script>
import db from '@/firebase/init'
import moment from 'moment'
export default {
    name:'Rate',
     data: () => ({
    dialog: false,
      search: '',
             pagination : {'sortBy': 'time', 'descending': true, 'rowsPerPage': -1},
    headers: [
      {
        text: 'ເວລາ',
        align: 'left',
       sortable: true,
        value: 'time'
      },
       { text: 'ກິບ (LAK)', value: 'lak',sortable: false,align: 'center' },
        { text: 'ໂດລາ (USD)', value: 'usd',sortable: false,align: 'center' },
     { text: 'Actions', value: 'name', sortable: false,align: 'center' }
    ],
    mydata: [],
    editedIndex: -1,
    editedItem: {
      usd: null,
      lak:null,
      datetime: Date.now(),
      stt:1
    },
    defaultItem: {
      usd: 0,
      lak:0,
      datetime: Date.now(),
      stt:1
    }
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'ເພີ່ມ' : 'ແກ້ໄຂ'
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    }
  },

  created () {
     this.initialize()
   // this.initialize()
  },

  methods: {
    initialize () {
        let tdata=[];
       let ref = db.collection('rate').where("stt","==",1).get()

        .then(snapshot => {
            snapshot.forEach(doc => {
              let tmpdata =doc.data();
              tmpdata.id =doc.id;
              tmpdata.time =moment(doc.data().timestamp).format('D-M-YYYY,  HH:mm');

              tdata.push(tmpdata);
            });
            this.mydata=tdata;
        })
        .catch(err => {
          console.log('Error getting documents', err);
        });
    },

    editItem (item) {
      this.editedIndex = this.mydata.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem (item) {
      const index = this.mydata.indexOf(item)
        if ( confirm('Are you sure you want to delete this item ('+item.time+' )?')) {
          // Delete it!
           db.collection('rate').doc(item.id).update({stt:0})
           this.mydata.splice(index, 1)
        }
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    save () {
      if (this.editedIndex > -1) {
       // Object.assign(this.mydata[this.editedIndex], this.editedItem)
        let id=this.editedItem.id;
        delete this.editedItem.id;
        this.editedItem.timestamp=Date.now();
        this.editedItem.datetime=new Date;
        this.editedItem.usd=parseFloat(this.editedItem.usd)
        this.editedItem.lak=parseInt(this.editedItem.lak)
        let ref = db.collection('rate').doc(id).update(this.editedItem)
      } else {
          this.editedItem.timestamp=Date.now();
          this.editedItem.datetime=new Date;
          this.editedItem.usd=parseFloat(this.editedItem.usd)
          this.editedItem.lak=parseInt(this.editedItem.lak)
        let ref = db.collection('rate').add(this.editedItem)
      }
      this.initialize()
      this.close()
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Rate.vue